import { createAction, createAsyncAction } from "typesafe-actions";
import { domain } from "./types/base.js";
const getEntityActions = () => ({
  fetch: createAction(`${domain}/fetch`)(),
  fetchRequest: createAsyncAction(`${domain}/fetchRequest`, `${domain}/fetchRequestSuccess`, `${domain}/fetchRequestFailure`)(),
  save: createAction(`${domain}/save`)(),
  clean: createAction(`${domain}/clean`)(),
  updateItem: createAction(`${domain}/updateItem`)(),
  increaseReferenceCounter: createAction(`${domain}/increaseReferenceCounter`)(),
  decreaseReferenceCounter: createAction(`${domain}/decreaseReferenceCounter`)(),
  cleanReferenceCounter: createAction(`${domain}/cleanReferenceCounter`)(),
  collectGarbage: createAction(`${domain}/collectGarbage`)(),
  fetchStatus: createAction(`${domain}/fetchStatus`)()
});
export {
  getEntityActions
};
//# sourceMappingURL=actions.js.map
